// extracted by mini-css-extract-plugin
module.exports = {"viewport":"_5sfmGUtsQENxilDBCKbnXw=="};